/**
 * Shared date formatting utilities.
 * All functions accept a Firestore Timestamp or a JS Date.
 */

/** Jan 5, 2025, 02:30 PM */
export function formatDateTime(ts) {
  if (!ts) return null;
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

/** Returns true if the timestamp is in the past and the status is not 'completed' */
export function isOverdue(ts, status) {
  if (!ts || status === 'completed') return false;
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d < new Date();
}
